<template>
  <!-- Generated code from animation export design -->
  <svg
    class="loader"
    id="eboPsOztc9I1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 300"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision">
    <g id="eboPsOztc9I2_to" transform="translate(198.115761,188.602575)">
      <g id="eboPsOztc9I2_ts" transform="scale(0.529455,0.529455)">
        <g id="eboPsOztc9I2" transform="translate(-198.229908,-145.783173)">
          <path
            id="eboPsOztc9I3"
            d="M72.360900,79.336960C72.360900,79.061010,72.389550,78.791750,72.444040,78.531990L47.475360,78.531990C47.529850,78.791750,47.558500,79.061010,47.558500,79.336960C47.558500,81.491600,45.811820,83.238280,43.657180,83.238280C41.502540,83.238280,39.755860,81.491600,39.755860,79.336960C39.755860,78.321620,40.143730,77.396870,40.779390,76.702800C40.143730,76.008730,39.755860,75.083980,39.755860,74.068640C39.755860,71.914000,41.502540,70.167320,43.657180,70.167320C45.811820,70.167320,47.558500,71.914000,47.558500,74.068640C47.558500,74.272650,47.542840,74.473000,47.512660,74.668560L72.406740,74.668560C72.376560,74.473000,72.360900,74.272650,72.360900,74.068640C72.360900,71.914000,74.107580,70.167320,76.262220,70.167320C78.416860,70.167320,80.163540,71.914000,80.163540,74.068640C80.163540,75.083980,79.775670,76.008730,79.140010,76.702800C79.775670,77.396870,80.163540,78.321620,80.163540,79.336960C80.163540,81.491600,78.416860,83.238280,76.262220,83.238280C74.107580,83.238280,72.360900,81.491600,72.360900,79.336960Z"
            transform="matrix(0.92718385456679 -0.37460659341591 0.37460659341591 0.92718385456679 179.91288362186975 65.48182219917467)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <path
            id="eboPsOztc9I4"
            d="M124.941740,89.214070C125.541080,90.146950,134.830840,106.029450,123.842950,105.929560C112.855060,106.029450,122.144820,90.146950,122.744160,89.214070C123.143720,88.592150,123.509980,87.704430,123.842950,86.550910C124.175920,87.704430,124.542180,88.592150,124.941740,89.214070Z"
            transform="matrix(0.96592582628907 -0.25881904510252 0.25881904510252 0.96592582628907 7.23071638772797 62.84436811786627)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <line
            id="eboPsOztc9I5"
            x1="0"
            y1="-11.437396"
            x2="0"
            y2="11.437396"
            transform="matrix(0.80132859736787 -0.21471535053669 0.21471535053669 0.80132859736787 153.18923291499999 129.87955299999996)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <path
            id="eboPsOztc9I6"
            d="M62.703506,124.608974Q71.793904,119.146526,74.290737,108.326917Q77.886774,104.031650,80.284132,108.826366Q77.230718,123.809855,62.703506,124.608974Z"
            transform="matrix(0.53370518893509 -1.39034955146515 1.39034955146515 0.53370518893509 -79.09759365476282 149.80399348193885)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.600000" />
          <path
            id="eboPsOztc9I7"
            d="M62.703506,96.240436C56.779621,99.363729,51.968153,102.869219,48.269102,106.756907C48.192520,106.614384,46.877458,109.770531,46.877458,112.926679C46.877458,113.014350,45.847606,109.437804,45.650067,109.682861C42.389746,114.055544,40.105466,119.369627,39.367643,124.608974C43.834922,124.608974,50.439298,118.829190,55.207381,112.829784C55.236507,112.770134,52.656349,112.763774,52.576703,112.684128C55.640091,111.485412,57.039243,110.241284,57.154340,110.220700C60.438238,105.294653,62.703506,100.066667,62.703506,96.240436"
            transform="matrix(1 0 0 1 173.02079599999999 5.91001500000000)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <path
            id="eboPsOztc9I8"
            d="M56.847021,103.597442Q45.253428,118.958953,35.398873,128.958428"
            transform="matrix(1 0 0 1 173.02079599999996 5.91001500000000)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000"
            stroke-linecap="round" />
          <rect
            id="eboPsOztc9I9"
            width="12.431999"
            height="16.685050"
            rx="4"
            ry="4"
            transform="matrix(1 0 0 1 174.65889463058764 107.12798995913910)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1" />
          <path
            id="eboPsOztc9I10"
            d="M108.284051,118.650984Q113.125499,118.113045,113.125499,113.809536"
            transform="matrix(-1 0 0 -1 282.31660363058768 238.82312095913909)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <path
            id="eboPsOztc9I11"
            d="M108.284051,118.650984Q113.125499,118.113045,113.125499,113.809536"
            transform="matrix(-1 0 0 1 282.31660363058768 -7.22871604086090)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <path
            id="eboPsOztc9I12"
            d="M108.284051,118.650984Q113.125499,118.113045,113.125499,113.809536"
            transform="matrix(1 0 0 -1 79.29198163058766 238.82312095913909)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <path
            id="eboPsOztc9I13"
            d="M108.284051,118.650984Q113.125499,118.113045,113.125499,113.809536"
            transform="matrix(1 0 0 1 79.29198163058766 -7.22871604086090)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <line
            id="eboPsOztc9I14"
            x1="-3.147419"
            y1="0"
            x2="3.147419"
            y2="0"
            transform="matrix(0.28997694650484 0.46406012011758 -0.80620618861314 0.50377353858398 178.49563413058766 105.47754195913909)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <line
            id="eboPsOztc9I15"
            x1="-3.147419"
            y1="0"
            x2="3.147419"
            y2="0"
            transform="matrix(0.28997694650484 -0.46406012011758 0.80620618861314 0.50377353858398 183.44370713058768 105.47754195913909)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <line
            id="eboPsOztc9I16"
            x1="-3.147419"
            y1="0"
            x2="3.147419"
            y2="0"
            transform="matrix(1 0 0 1 190.21809513058764 115.47728595913910)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <line
            id="eboPsOztc9I17"
            x1="-3.147419"
            y1="0"
            x2="3.147419"
            y2="0"
            transform="matrix(1 0 0 1 171.21809513058764 115.47728595913910)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1"
            stroke-linecap="round" />
          <line
            id="eboPsOztc9I18"
            x1="-6.073683"
            y1="0"
            x2="6.073683"
            y2="0"
            transform="matrix(1 0 0 1 181.03790063058764 111.85857595913909)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="1" />
          <ellipse
            id="eboPsOztc9I19"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 119.56564325000002 133.01922025000002)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I20"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 132.84114525000001 96.95740824999999)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I21"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 160.68007225000002 109.93569724999999)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I22"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 169.49738325000001 133.81178724999998)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I23"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 197.31376325000002 126.95703624999999)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I24"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 222.05047225000001 144.34227424999997)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I25"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 236.25669525000001 128.34785524999998)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I26"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 205.37486325000000 117.43345425000001)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I27"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 244.04060925000002 106.18062225000001)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I28"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(0.42941543148646 0 0 0.42941543148646 274.66861825000001 121.83305725000001)"
            fill="rgb(255,255,255)"
            stroke="rgb(5,5,5)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I29"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 291.26894425000000 117.05517225000000)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I30"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 238.28982224999999 138.01647724999998)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I31"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 262.01525525000000 102.54350024999999)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I32"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 185.31070124999999 136.17372524999999)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I33"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 211.80026125000001 104.38625225000000)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I34"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 144.30946724999998 105.99866024999999)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I35"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 140.62396325000000 134.56131725000000)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
          <ellipse
            id="eboPsOztc9I36"
            rx="2.804615"
            ry="2.804615"
            transform="matrix(1 0 0 1 122.19644325000000 87.34079525000001)"
            fill="none"
            stroke="rgb(255,255,255)"
            stroke-width="0.800000" />
        </g>
      </g>
    </g>
    <g id="eboPsOztc9I37_to" transform="translate(200,230.897704)">
      <g id="eboPsOztc9I37_ts" transform="scale(0.951946,0.936908)">
        <rect
          id="eboPsOztc9I37"
          width="101.774530"
          height="80.897704"
          rx="4"
          ry="4"
          transform="translate(-50.887265,-80.897704)"
          fill="rgb(0,0,0)"
          stroke="rgb(255,255,255)"
          stroke-width="1" />
      </g>
    </g>
    <g id="eboPsOztc9I38_to" transform="translate(199.217119,179.834463)">
      <g id="eboPsOztc9I38_ts" transform="scale(1,1)">
        <rect
          id="eboPsOztc9I38"
          width="32.881002"
          height="8.762872"
          rx="2"
          ry="2"
          transform="translate(-16.440501,-4.381436)"
          fill="none"
          stroke="rgb(255,255,255)"
          stroke-width="1" />
      </g>
    </g>
    <g id="eboPsOztc9I39_to" transform="translate(200,153.966597)">
      <g id="eboPsOztc9I39_tr" transform="rotate(0)">
        <rect
          id="eboPsOztc9I39"
          width="110.647182"
          height="24.008350"
          rx="4"
          ry="4"
          transform="scale(1.008130,1) translate(-55.323591,-12.004175)"
          fill="rgb(0,0,0)"
          stroke="rgb(255,255,255)"
          stroke-width="1" />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped>
.loader {
  width: 600px;
}

// Generated code from animation export design
#eboPsOztc9I2_to {
  animation: eboPsOztc9I2_to__to 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I2_to__to {
  0% {
    transform: translate(198.115761px, 188.602575px);
  }
  46.666667% {
    transform: translate(198.115761px, 188.602575px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  53.333333% {
    transform: translate(198.115761px, 155.297583px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  90% {
    transform: translate(198.115761px, 155.297583px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  96.666667% {
    transform: translate(198.115761px, 194.621791px);
  }
  100% {
    transform: translate(198.115761px, 194.621791px);
  }
}
#eboPsOztc9I2_ts {
  animation: eboPsOztc9I2_ts__ts 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I2_ts__ts {
  0% {
    transform: scale(0.529455, 0.529455);
  }
  46.666667% {
    transform: scale(0.529455, 0.529455);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  56.666667% {
    transform: scale(1, 1);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  90% {
    transform: scale(1.023394, 1.023394);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  96.666667% {
    transform: scale(0.483528, 0.483528);
  }
  100% {
    transform: scale(0.483528, 0.483528);
  }
}
#eboPsOztc9I37_to {
  animation: eboPsOztc9I37_to__to 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I37_to__to {
  0% {
    transform: translate(200px, 230.897704px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  50% {
    transform: translate(200px, 230.897704px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  53.333333% {
    transform: translate(200px, 220.897704px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  56.666667% {
    transform: translate(200px, 230.897704px);
  }
  100% {
    transform: translate(200px, 230.897704px);
  }
}
#eboPsOztc9I37_ts {
  animation: eboPsOztc9I37_ts__ts 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I37_ts__ts {
  0% {
    transform: scale(0.951946, 0.936908);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  46.666667% {
    transform: scale(1.04682, 0.802515);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  53.333333% {
    transform: scale(0.951946, 0.936908);
  }
  100% {
    transform: scale(0.951946, 0.936908);
  }
}
#eboPsOztc9I38_to {
  animation: eboPsOztc9I38_to__to 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I38_to__to {
  0% {
    transform: translate(199.217119px, 179.834463px);
  }
  46.666667% {
    transform: translate(199.217119px, 189.834463px);
  }
  53.333333% {
    transform: translate(199.217119px, 170.439891px);
  }
  56.666667% {
    transform: translate(199.217119px, 179.834463px);
  }
  100% {
    transform: translate(199.217119px, 179.834463px);
  }
}
#eboPsOztc9I38_ts {
  animation: eboPsOztc9I38_ts__ts 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I38_ts__ts {
  0% {
    transform: scale(1, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  46.666667% {
    transform: scale(1.156593, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  53.333333% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}
#eboPsOztc9I39_to {
  animation: eboPsOztc9I39_to__to 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I39_to__to {
  0% {
    transform: translate(200px, 153.966597px);
  }
  46.666667% {
    transform: translate(200px, 164.966597px);
  }
  53.333333% {
    transform: translate(200px, 84.966597px);
  }
  90% {
    transform: translate(200px, 79.966597px);
  }
  96.666667% {
    transform: translate(200px, 156.966597px);
  }
  100% {
    transform: translate(200px, 153.966597px);
  }
}
#eboPsOztc9I39_tr {
  animation: eboPsOztc9I39_tr__tr 3000ms linear infinite normal forwards;
}
@keyframes eboPsOztc9I39_tr__tr {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  13.333333% {
    transform: rotate(4deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  26.666667% {
    transform: rotate(-4deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  36.666667% {
    transform: rotate(2deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  46.666667% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  53.333333% {
    transform: rotate(-2deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  90% {
    transform: rotate(-2deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  93.333333% {
    transform: rotate(-2deg);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  96.666667% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
